/**
 * Google Ads click attribution capture for offline conversion import.
 * Captures ?gclid + campaign/keyword (utm_*) on landing (from an ad click),
 * stores first-party for 90 days, exposes it to the enquiry form so booked
 * leads upload back to Google Ads with campaign attribution. GCLIDs are
 * case-sensitive — never transform them.
 */
const KEY = 'corvana_gclid';
const TTL_MS = 90 * 24 * 60 * 60 * 1000;

export function captureGclid() {
  if (typeof window === 'undefined') return;
  try {
    const p = new URLSearchParams(window.location.search);
    const gclid = p.get('gclid');
    const gclsrc = p.get('gclsrc');
    if (gclid && (!gclsrc || gclsrc.includes('aw'))) {
      localStorage.setItem(KEY, JSON.stringify({
        value: gclid,
        gclsrc: gclsrc || '',
        campaign: p.get('utm_campaign') || p.get('campaignid') || '',
        keyword: p.get('utm_term') || p.get('keyword') || '',
        source: p.get('utm_source') || 'google',
        medium: p.get('utm_medium') || 'cpc',
        expiresAt: Date.now() + TTL_MS,
      }));
    }
  } catch { /* ignore */ }
}

function _read() {
  try {
    const item = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!item || item.expiresAt <= Date.now()) { localStorage.removeItem(KEY); return null; }
    return item;
  } catch { return null; }
}

export function getGclid() { return _read()?.value || null; }
export function getAdAttribution() {
  const i = _read();
  if (!i) return {};
  return { gclid: i.value, ads_campaign: i.campaign || '', ads_keyword: i.keyword || '', ads_source: i.source || '' };
}

// Capture immediately on first load (the ad click lands with ?gclid).
captureGclid();
